var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlueDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.806 1.172A1 1 0 016.22 2.586L1.978 6.829A1 1 0 11.563 5.414l4.243-4.242z",
    fill: "#005FF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.194 1.172A1 1 0 104.78 2.586l4.243 4.243a1 1 0 001.414-1.415L6.194 1.172z",
    fill: "#005FF9"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC44MDYgMS4xNzJBMSAxIDAgMDE2LjIyIDIuNTg2TDEuOTc4IDYuODI5QTEgMSAwIDExLjU2MyA1LjQxNGw0LjI0My00LjI0MnoiIGZpbGw9IiMwMDVGRjkiLz48cGF0aCBkPSJNNi4xOTQgMS4xNzJBMSAxIDAgMTA0Ljc4IDIuNTg2bDQuMjQzIDQuMjQzYTEgMSAwIDAwMS40MTQtMS40MTVMNi4xOTQgMS4xNzJ6IiBmaWxsPSIjMDA1RkY5Ii8+PC9zdmc+";
export { SvgArrowBlueDown as ReactComponent };